module.exports = __webpack_public_path__ + "img/sponsor_7.6973452f.png";